<template lang="pug">
#visitors-index.grid-scroll-more(v-if="!loading", v-scrolled-to-end="fetchMore")
  PageHeader(headerText="Visitors", :sortOptions="sortOptions", @sortBy="setSortOrder")
  GridDisplay(:entities="users")
</template>

<script>
import { mapGetters } from 'vuex'
import fetchAndSort from '@/mixins/fetchAndSort'

export default {
  mixins: [fetchAndSort],
  props: {},

  data() {
    return {
      fetchType: 'users/fetchVisitors',
      loading: true,
      sortOrder: 'recent',
      sortOptions: ['recent', 'most visits'],
    }
  },

  channels: {
    UserVisitorsChannel: {
      connected() {},
      rejected() {},
      received(data) {
        console.log('VisitorsIndex.vue :29', 'data')
        if (this.sortOrder == 'recent') {
          this.$store.commit('users/ADD_OR_UPDATE', data)
        } else {
          this.$store.commit('users/UPDATE', data)
        }
      },
      disconnected() {},
    },
  },

  computed: {
    ...mapGetters({
      sortBy: 'users/sortBy',
    }),
    users,
  },

  watch: {},

  async created() {
    await this.fetchRecords()
    this.loading = false
  },

  methods: {},

  mounted() {
    this.$cable.subscribe({ channel: 'UserVisitorsChannel', id: this.$app.user.id })
  },

  components: {
    GridDisplay: require('@/components/GridDisplay').default,
    PageHeader: require('@/components/PageHeader').default,
  },
}

/* Computed ---------------------------------------------------- */
function users() {
  return this.sortBy(this.sortOrder)
}
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
